import { createSelector } from 'reselect'
import { getAttributes } from '../../imports'

export const getDownloadEverything = state =>
    state.backendReducer.settings.LauncherShouldDownloadEverything
export const getRunClientsWithLogging = state =>
    state.backendReducer.settings.LauncherRunClientsWithLogging
export const getRunClientsWithDx9 = state => state.backendReducer.settings.LauncherRunClientsWithDx9
export const getShouldMinimizeToTray = state =>
    state.backendReducer.settings.LauncherShouldMinimizeToTray
export const getLocale = state => state.backendReducer.settings.LauncherLanguage
export const getTestServers = state => state.backendReducer.settings.LauncherTestServers
export const getLauncherTypeId = state => state.backendReducer.settings.LauncherType

// Used for getting state to send down to backend
export const getBackendSettings = state => ({
    ...state.backendReducer.settings,
    // Default to 'Duality'
    LauncherTestServers: [...(state.backendReducer.settings.LauncherTestServers || ['Duality'])],
    // English should be an empty string
    LauncherLanguage:
        state.backendReducer.settings.LauncherLanguage === 'en'
            ? ''
            : state.backendReducer.settings.LauncherLanguage,
})

export const getLauncherType = createSelector(
    [getLocale, getLauncherTypeId],
    (locale, launcherTypeId) => getAttributes(locale).versionTypes[launcherTypeId],
)



// WEBPACK FOOTER //
// ./src/features/Backend/data/settings/selectors.js